import script from "./InstantFundingView.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantFundingView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__